<template>
  <div class="appBody bg-white">
<!--    <div class="shareImg position-fixed cursor-pointer">-->
<!--      <img @click="onShare" src="/static/img/pro/share.png" alt="" class="">-->
<!--    </div>-->
    <little-header></little-header>
    <div class="px-3">
      <p class="pt-3 text-center mb-2r color-0d font-18 line-24 van-multi-ellipsis--l2">
        {{article.title}}
      </p>
      <p class="mb-5 news-detail-content word-break" v-html="content">
      </p>

    </div>
    <little-footer></little-footer>
  </div>
</template>

<script>
  import LittleHeader from "@/components/littleHeader";
  import littleFooter from '@/page/lecturer/components/littleFooter';

  export default {
    name: "articleComponent",
    components: {
      LittleHeader,
      littleFooter,
    },
    data() {
      return {
        articleId: '',
        shareObj: {},
        content: '',
        article: {}
      }
    },
    mounted() {
      this.articleId = this.$route.params['id'];
      this.getNewsContent();
    },
    methods: {
      getNewsContent() {
        this.$store.dispatch('getContentUrl', {id: this.articleId}).then((res) => {
          this.article = res;
          this.getContent();
        })
      },
      getContent() {
        this.$store.dispatch('getContent', {content: this.article.content}).then((result) => {
          this.content = result;
        }).catch(error => {
          console.log(error)
        })
      }
      // onShare() {
      //   //把生成海报需要的信息传入cookie
      //
      //   this.shareObj = this.article;
      //   this.shareObj.qrcodeUrl = window.location.href;
      //   this.shareObj.fromPageType = 'news';
      //   localStorage.setItem('share_obj', JSON.stringify(this.shareObj));
      //   this.$router.push('/share-poster')
      // }
    }
  }
</script>

<style>

</style>
